module.exports = __webpack_public_path__ + "img/tab-device-lock-selected.8c3f624b.png";